import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "legacyFields",
    "nomenclaturePanel",
    "rebuildFlag",
    "nameInput",
  ];

  enableRebuild(event) {
    event.preventDefault();

    if (this.hasRebuildFlagTarget) {
      this.rebuildFlagTarget.value = "1";
    }

    if (this.hasLegacyFieldsTarget) {
      this.legacyFieldsTarget.classList.add("d-none");
    }

    if (this.hasNomenclaturePanelTarget) {
      this.nomenclaturePanelTarget.classList.remove("d-none");
    }

    if (this.hasNameInputTarget) {
      this.nameInputTarget.disabled = true;
    }

    const composedNameField = this.nomenclaturePanelTarget?.querySelector(
      'input[name="event[name]"]'
    );
    if (composedNameField) {
      composedNameField.disabled = false;
    }

    const nomenclatureRoot = this.nomenclaturePanelTarget?.querySelector(
      "[data-controller~='event-nomenclature']"
    );
    if (nomenclatureRoot && this.application) {
      const nomenclatureController =
        this.application.getControllerForElementAndIdentifier(
          nomenclatureRoot,
          "event-nomenclature"
        );
      nomenclatureController?.updatePreview();
    }

    const firstSelect = this.nomenclaturePanelTarget?.querySelector(
      "select.event-nomenclature__select"
    );
    if (firstSelect) firstSelect.focus();
  }
}
